module.exports = __webpack_public_path__ + "static/media/information.a07a04e1.svg";